import _pt from "prop-types";
import React from 'react';
import * as Styled from './FabricTag.styles';

var FabricTag = function FabricTag(props) {
  var label = props.label;
  if (!label) return null;
  return /*#__PURE__*/React.createElement(Styled.Tag, null, /*#__PURE__*/React.createElement("span", null, label));
};

FabricTag.propTypes = {
  label: _pt.string
};
export default FabricTag;